import { render, staticRenderFns } from "./RemoverUsuarioOrganizacaoModal.vue?vue&type=template&id=70aef3b0&scoped=true&"
import script from "./RemoverUsuarioOrganizacaoModal.vue?vue&type=script&lang=js&"
export * from "./RemoverUsuarioOrganizacaoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70aef3b0",
  null
  
)

export default component.exports